module.exports = __webpack_public_path__ + "img/MEDIA083.e3daf63f.jpg";